// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert{border:1px solid #d6e9c6;border-radius:4px;padding:15px;color:#3c763d;background:#dff0d8}.alert.alert--error{color:#a94442;background-color:#f2dede;border-color:#ebccd1}", ""]);
// Exports
module.exports = exports;
